import React, { useState } from 'react'

import T from 'utils/useLocalizer'
import { buttons } from 'utils/resources'
import ModalWrapper, { ModalFooter } from 'components/ui/modal/ModalWrapper'
import InlineSpinner from 'components/ui/spinner/InlineSpinner'

interface Props {
    show: boolean
    title?: string
    // if message is provided, it will be shown instead of children
    message?: string    
    confirmBtnText?: string
    cancelBtnText?: string
    confirmHandler: () => any
    closeHandler: () => any | Promise<any>
    // optional children to render additional content
    children?: React.ReactNode | React.ReactNode[]
}

const ConfirmModal = ({ show, title, message, confirmBtnText, cancelBtnText, confirmHandler, closeHandler, children }: Props) => {
    const resources = {
        modalTitle: T(title ?? ''),
        modalMessage: T(message ?? ''),
        buttonConfirm: T(confirmBtnText ?? buttons.ok),
        buttonContinueEditing: T(cancelBtnText ?? buttons.cancel),
    }

    const [isLoading, setLoading] = useState<boolean>(false);

    const onConfirm = async () => {
        setLoading(true)
        confirmHandler()?.finally(() => setLoading(false))
    }

    return (
        <ModalWrapper show={show} closeButton onHide={closeHandler} title={resources.modalTitle} backdrop='static' isSecondModal>
            {message ? <p>{resources.modalMessage}</p> : children ? children : null}

            <ModalFooter className='justify-content-end'>
                <button className='btn btn-secondary' onClick={closeHandler} disabled={isLoading}>{resources.buttonContinueEditing}</button>
                <button className='btn btn-primary' onClick={onConfirm} disabled={isLoading}><span>{resources.buttonConfirm}</span>
                    {isLoading && <span className='ms-2'><InlineSpinner small /></span>}
                </button>
            </ModalFooter>
        </ModalWrapper>
    )
}

export default ConfirmModal